// Acción única utilizada por todos los CTA. ImpulTienda puede vincular su checkout
// buscando data-impultienda-checkout="true" o escuchando el evento impultienda:checkout.
export const CHECKOUT_BUTTON_ATTRS = {
  'data-impultienda-checkout': 'true'
} as const;

export function goToCheckout() {
  window.dispatchEvent(new CustomEvent('impultienda:checkout'));

  const offer = document.getElementById('oferta-final');
  const trigger = document.activeElement;
  const isAlreadyAtCheckout = offer && trigger instanceof Node && offer.contains(trigger);

  if (offer && !isAlreadyAtCheckout) {
    offer.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}
